// The rows of a Clients list page, each with its client's automatic invoicing counts from the statuses sent for the
// page. Only clients with setups have a status; the others get zero of each.
export function addClientInvoiceAutomationCounts(clients, clientStatuses) {
  return clients.map((client) => {
    const clientStatus = clientStatuses.find((candidate) => candidate.clientId === client.clientId);
    return {
      ...client,
      invoiceAutomationActiveCount: clientStatus ? clientStatus.activeCount : 0,
      invoiceAutomationDeactivatedCount: clientStatus ? clientStatus.deactivatedCount : 0,
    };
  });
}

// The badges of a client's automated projects on the Clients list: "2 active" in green and "1 deactivated" in red,
// leaving out a count of zero, so a client without setups has none.
export function getClientInvoiceAutomationBadges(activeCount?: number | null, deactivatedCount?: number | null) {
  const badges = [];
  if (activeCount > 0) {
    badges.push({ variant: 'active', label: `${activeCount} active` });
  }
  if (deactivatedCount > 0) {
    badges.push({ variant: 'deactivated', label: `${deactivatedCount} deactivated` });
  }
  return badges;
}
